import React from "react";
import { FiPlus, FiActivity } from "react-icons/fi";
import { User, Avaliation } from "../../../types";
import { calculateIMC as calcIMC } from "../../../helpers/avaliationCalculations";
import avaliations from "../../../services/avaliations";
import {
  EmptyState,
  AvaliationCard,
  SectionHeader,
  PrimarySectionButton,
  LIST_GRID_CLASS,
} from "./StudentManagementModalComponents";
import {
  safeNumber,
  getAvaliationTimestamp,
} from "./StudentManagementModalUtils";
import { AvaliationTabSkeleton } from "./StudentManagementModalSkeletons";

interface AvaliationHistoryItem extends Avaliation {}

interface StudentManagementModalAvaliationTabProps {
  student: User;
  avaliationList: AvaliationHistoryItem[];
  loading: boolean;
  professionalId: string;
  onOpenNewAvaliation: () => void;
  onOpenEditAvaliation: (av: Avaliation) => void;
  onOpenBodyModal: (av: Avaliation) => void;
  onDataReload: () => void;
}

export default function StudentManagementModalAvaliationTab({
  student,
  avaliationList,
  loading,
  professionalId,
  onOpenNewAvaliation,
  onOpenEditAvaliation,
  onOpenBodyModal,
  onDataReload,
}: StudentManagementModalAvaliationTabProps) {
  if (loading) {
    return <AvaliationTabSkeleton />;
  }

  return (
    <div className="space-y-3 sm:space-y-4 md:space-y-6">
      <SectionHeader
        title="Histórico de Avaliações"
        description="Acompanhe a evolução física do aluno"
        actionButton={
          <PrimarySectionButton
            icon={FiPlus}
            label="Nova Avaliação"
            onClick={onOpenNewAvaliation}
          />
        }
      />

      {avaliationList.length === 0 ? (
        <EmptyState
          icon={FiActivity}
          title="Nenhuma avaliação encontrada"
          description="Comece criando a primeira avaliação para este aluno"
        />
      ) : (
        <div className={LIST_GRID_CLASS}>
          {[...avaliationList]
            .sort(
              (a, b) => getAvaliationTimestamp(b) - getAvaliationTimestamp(a),
            )
            .map((av) => {
              const pesoNum = safeNumber(av.peso);
              const pesoDisplay =
                pesoNum && !Number.isNaN(pesoNum) ? `${pesoNum}kg` : "-";
              const imcNum = calcIMC(av);
              const imcDisplay =
                imcNum !== null && !Number.isNaN(imcNum)
                  ? imcNum.toFixed(1)
                  : "-";

              return (
                <AvaliationCard
                  key={av.id}
                  avaliation={av}
                  pesoDisplay={pesoDisplay}
                  imcDisplay={imcDisplay}
                  onView={() => onOpenBodyModal(av)}
                  onEdit={() => onOpenEditAvaliation(av)}
                  onDelete={() => {
                    if (
                      window.confirm(
                        "Tem certeza que deseja excluir esta avaliação?",
                      )
                    ) {
                      avaliations
                        .remove(String(av.id))
                        .then(() => onDataReload());
                    }
                  }}
                />
              );
            })}
        </div>
      )}
    </div>
  );
}
